import React from 'react';

import { ClickAwayListener, Paper, Popover } from '@material-ui/core';

type InputProps = {
  anchorRef: React.MutableRefObject<HTMLDivElement | null>;
  children: React.ReactNode;
  isShowingPopover: boolean;
  onClose: () => void;
  /** While the popover should center on the anchor element, custom margins will most likely be needed
   *  in each case to make it visually look centered with the icon/element */
  margins?: { marginTop: number; marginLeft: number };
};

export const UiPopover = (props: InputProps) => {
  const { anchorRef, children, isShowingPopover, onClose, margins = {} } = props;

  return (
    <Popover
      open={isShowingPopover}
      anchorEl={anchorRef.current}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      // The styling here is a bit complex, so I'll try to break it down.
      // First, we need to hide the Popover boxShadow - since the triangle lives inside the component,
      //   the shadow expands beyond the white background as is.
      // The triangle lives inside the component, so it has the same transition animation and centering.
      // We have a margin and actual boxShadow on the Paper element to give us the elevated look for the
      //   popover. The margin is needed so the shadow has space to expand into. However, the margin
      //   makes the popover not centered with the anchor element, so we have a custom style to bump
      //   the popover back to center.
      classes={{ paper: 'u-background-transparent u-boxShadow-none' }}
      style={margins}
    >
      <div className="u-flex-center u-flexDirection-column">
        <div className="triangle-up" />
      </div>
      <Paper className="u-margin-top-md u-margin-2x u-elevation-3">
        <ClickAwayListener onClickAway={onClose}>
          <div className="u-borderRadius-3 u-background-white u-padding-md">{children}</div>
        </ClickAwayListener>
      </Paper>
    </Popover>
  );
};
